import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Program from "@/components/landing/Program";
import Manifesto from "@/components/landing/Manifesto";
import AboutMentor from "@/components/landing/AboutMentor";
import Pricing from "@/components/landing/Pricing";
import EnquiryForm from "@/components/landing/EnquiryForm";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";

export default function Landing() {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Program />
        <Manifesto />
        <AboutMentor />
        <Pricing />
        <EnquiryForm />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
